import { SupervisorAccount } from '@mui/icons-material'

const accountingIndex = {
  icon: SupervisorAccount,
}

export default accountingIndex
